import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { RiskyEntity } from '../../types';
import { buildUniversalMfaDomainQueryParams } from '../constants/utils';
import { QueryFiltersDomainOnly } from '../types';

const END_POINT = '/metric/riskyResources';
const LIMIT = 9;

type RiskyResourcesDto = RiskyEntity;

const convertToRiskyResources = (data: RiskyResourcesDto[]): RiskyEntity[] => {
    return data.map((item) => ({
        name: item.name,
        guid: item.guid,
        riskLevel: item.riskLevel
    }));
};

const fetchRiskyResources = async (filters: QueryFiltersDomainOnly): Promise<RiskyResourcesDto[]> => {
    const data = await apiGet<RiskyResourcesDto[]>(`${API_BASE_URL}${END_POINT}`, {
        ...buildUniversalMfaDomainQueryParams(filters),
        limit: LIMIT.toString()
    });
    return data;
};

export const useRiskyResources = (filters: QueryFiltersDomainOnly): UseQueryResult<RiskyEntity[]> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.riskyResources(filters),
        queryFn: () => fetchRiskyResources(filters),
        select: convertToRiskyResources
    });
};
